import { Link, NavLink } from 'react-router-dom';
import { cx } from '@platform/core/lib/cx';
import type { IMenuPagesProps } from './IMenuPagesProps';
import { PageIcon } from './PageIcon';

/**
 * Сторінки модуля над групами записів (прототип v4): рядки 34px з іконкою 15px (PageIcon), лінія зверху блоку; активна сторінка — за маршрутом
 * (тло --accent-soft, текст --accent, 600; NavLink ставить aria-current="page") або за власним правилом посилання (`active`). Які сторінки
 * показувати в контексті меню (запис, налаштування, проєктування), вирішує pagesForContext; без сторінок блоку немає.
 */
export function MenuPages({ links }: IMenuPagesProps) {
  if (!links.length) return null;
  return (
    <div className="mnav__pages">
      {links.map((l) => {
        const body = <><PageIcon name={l.icon ?? 'chart-line'} size={15} className="mnav__icon" /><span className="mnav__label" title={l.label}>{l.label}</span></>;
        return l.active === undefined ? (
          <NavLink key={l.key} to={l.to} className={({ isActive }) => cx('mnav__page', l.plain && 'is-plain', isActive && 'is-active')}>{body}</NavLink>
        ) : (
          <Link key={l.key} to={l.to} className={cx('mnav__page', l.plain && 'is-plain', l.active && 'is-active')} aria-current={l.active ? 'page' : undefined}>{body}</Link>
        );
      })}
    </div>
  );
}
